import React, { Component } from 'react';

import { Header, Navbar } from '@C';
import { PurchaseOrder } from '@C/CreditCustomerProfile/PurchaseOrder';
import ErrorBoundary from '@C/Error';

class PurchaseOrderPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <main>
        <div className="page-wrapper">
          <Header title="Generate puchase order" />
          <Navbar />
          <div className="page-content">
            <section className="page-components">
              <ErrorBoundary>
                <PurchaseOrder />
              </ErrorBoundary>
            </section>
          </div>
        </div>
      </main>
    );
  }
}

export { PurchaseOrderPage };
